import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { MEMBERSHIP_USER_ACCESS_LEVEL } from 'src/features/membership/types';
import { MembershipCloudUserEditFormSchemaValues } from 'src/features/membershipCloudUsers/utils/formSchema';

const RESOURCE = `sp-core/:parkingId/memberships/membership/:membershipId/cloud-users/:userId/`;

type MutationFnType = typeof mutationFn;

interface DTO extends MembershipCloudUserEditFormSchemaValues {
    parkingId: string;
    membershipId: string;
    userId: string;
}
const mutationFn = ({
    parkingId,
    membershipId,
    userId,
    ...data
}: DTO): Promise<{ access_level: MEMBERSHIP_USER_ACCESS_LEVEL }> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, membershipId, userId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateMembershipCloudUser };
